import axios from 'axios'

import { checkToken } from '../auth/hooks/useToken'

export const billingEngineApi = axios.create({
  baseURL: '/billing-engine/api/v1',
})

billingEngineApi.interceptors.request.use(function (config) {
  return checkToken(config)
})
